/** 手动引入PDF.js  */

const loadCustomPDFJS = new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.src = 'https://asset.esign.cn/apps/esign-pdf/2.3.2/pdf.js'
  script.onload = () => {
    resolve(window.pdfjsLib)
  }
  script.onerror = err => {
    reject(err)
  }
  ;(document.head || document.documentElement).appendChild(script)
})

export default async function getPdfDoc(downloadUrl, params = {}) {
  if (!downloadUrl) return

  return new Promise((resolve, reject) => {
    loadCustomPDFJS.then(PDFJS => {
      // 配置 PDF Worker 的路径
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://asset.esign.cn/apps/esign-pdf/2.3.2/pdf.worker.min.js'

      PDFJS.getDocument({
        url: downloadUrl,
        cMapUrl: 'https://asset.esign.cn/apps/esign-pdf/fonts/',
        cMapPacked: true,
        ...params,
      })
        .promise.then(pdfDocument => {
          resolve(pdfDocument)
        })
        .catch(reason => {
          reject(reason)
          console.error('PDF加载失败', reason)
        })
    })
  })
}
